import { ChangeDetectorRef, Component, EventEmitter, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges} from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-manager-feedback',
  templateUrl: './manager-feedback.component.html',
  styleUrls: ['./manager-feedback.component.scss'],
})
export class ManagerFeedbackComponent  implements OnInit {

  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  selectedYear: any;
  toYear: any;
  selectedYearForCompetency: any = null;
    pmsYears: any = [];
  programForm!: FormGroup;
  selectedTabIndex: number = 0;  // Default tab is "Create Calendar"
  searchTerm:any;
    selectedTypeTabIndex: number = 0;
    selectedTypeTabName = 'createcalendar'
    buttonColorName: any;
    showSetupPopup: boolean = false;
  getProgramme: any;
    constructor(private datePipe: DatePipe, public sharedService: SharedService,
      private loader: LoaderService, private encryptionService: EncryptionService,
      private httpService: HttpService, private config: Config, public router: Router,
      private fb: FormBuilder, public dialog: MatDialog,
      private activatedroute: ActivatedRoute, private toastr: ToastrService,
      private toastController: ToastController,
      private cdRef: ChangeDetectorRef,
      private PdfDownload: PdfDownloadService, private dataRefreshService: DataRefreshService,) { 
        this.programForm = this.fb.group({
          selectedProgram: [''] // Default empty selection
        });
      }
    

    ngOnInit() {
      this.selectedTypeTabName = "createcalendar";
      this.buttonColorName = sessionStorage.getItem('buttonColorName');
      this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
      this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
  
      console.log('loggedInUserCompanyID Value:', this.loggedInUserCompanyID); // Debugging
  
      this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
      this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
      if (this.loggedInCompanyFiscalyear) {
        this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
      }
      this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
      this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
      this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
      this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
      if (this.loggedInUserRole) {
        this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      }
      this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
      this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
      if (this.loggedInUserRoles.length == 1) {
        for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
          if (this.loggedInUserRoles[i].displayName == "Employee") {
            this.loggedInUserRoleIsEmployee = true
          }
        }
      }
      this. getpmsyearlist();
    }
  
  
    getpmsyearlist() {
      this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
        this.pmsYears = formatYearRanges(data?.data?.yearRanges);
  
        const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
  
        const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
        
        this.setSelectedYear(yearValue);
  
      });
    }
    
    getYearSetupForReimbursement(year: any) {
      this.selectedYearForCompetency = year;
  console.log(   this.selectedYearForCompetency);
  
      this.selectedYear = year;
      // console.log(this.selectedYear)
     
    }
    
    setSelectedYear(yearValue: string): void {
      const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
      if (selectedYearObj) {
            this.selectedYearForCompetency = selectedYearObj?.year;
           
            let test = selectedYearObj?.year.split('-');
            this.fromYear = test[0];
            this.toYear = test[1];
            this.getAllProgramme();
            [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
      }
    }
  

     


    selectTab(tab: string) {
      this.selectedTypeTabName = tab;
    }
    
    tabTypeChanged(event: MatTabChangeEvent) {
      this.selectedTypeTabName = event.tab.textLabel;
      this.selectedTypeTabIndex = event?.index;
    }
  
    tableHeaders = [
      { label: 'Training Type', key: 'trainingType' },
      { label: 'Programme Title', key: 'title' },
      { label: 'Programme Code', key: 'code' },
      { label: 'LMS Link', key: 'lmsLink' },
      { label: 'Start Date', key: 'startDate' },
      { label: 'End Date', key: 'endDate' },
      { label: 'Start Time', key: 'endDate' },
      { label: 'End Time', key: 'endDate' },
      { label: 'Functional/Behavioral', key: 'category' },
      { label: 'Dept.', key: 'department' },
      { label: 'Band', key: 'band' },
      { label: 'Grade', key: 'grade' },
      { label: 'Location', key: 'location' },
      { label: 'No. of Program Days', key: 'programDays' },
      { label: 'Objective', key: 'objective' },
    ];
    

    programList=['Online','Offline'];
    
getAllProgramme(){
  let companyId = this.loggedInUserCompanyID;
      let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      let fiscal_year = this.loggedInCompanyFiscalyear;
      this.httpService.callGetService(this.config.getAllProgram + fiscal_year+"/"+year+"/"+companyId).subscribe((result: any) => {
       this.getProgramme = result.data;
       console.log("Get all programme====", this.getProgramme);
       
        })     
}



facultyNamePopup(){
  
}

//=============================== Dropdown for Programm================================
dropdownSettings = {
  singleSelection: false,  // or true based on your requirement
  idField: 'id',
  textField: 'name',
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  itemsShowLimit: 1,
  allowSearchFilter: true
};

getProgramList: any[]=[];


onProgramSelect(){

}

onProgramDeSelect(){

}
onProgramAllSelect(){

}
onProgramAllDeSelect(){

}


// ===========Dropdown for the Employee=======

getEmployeeList:any[]=[];

onEmployeeSelect(){

}

onEmployeeDeSelect(){
  
}

onEmployeeAllSelect(){
  
}

onEmployeeAllDeSelect(){
  
}





// ===================================== Manger feedback Form =================================================

    // ==============Manager  Feedback ===========================
    questions = [
      {
        id: 'Q1',
        question: 'How do you rate the work environment?',
        selected: 0, // will be updated by user
        ratings: [
          { value: 1, label: 'Bad' },
          { value: 2, label: 'Average' },
          { value: 3, label: 'Good' },
          { value: 4, label: 'Awesome' },
          { value: 5, label: 'Excellent' }
        ]
      },
      {
        id: 'Q2',
        question: 'How do you rate the leadership support?',
        selected: 0,
        ratings: [
          { value: 1, label: 'Poor' },
          { value: 2, label: 'Fair' },
          { value: 3, label: 'Good' },
          { value: 4, label: 'Very Good' },
          { value: 5, label: 'Outstanding' }
        ]
      }
    ];
  
    submitRatings() {
      const payload = this.questions.map(q => ({
        questionId: q.id,
        selected: q.selected
      }));
      console.log('Submitted Ratings:', payload);
  
     
    }


      
// ========================= Filters ==========================================
filterEmployees() {
  // this.employees = this.filteredEmployees.filter((emp: any) =>
  //   emp?.firstName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
  //   emp?.lastName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
  //   emp?.salutation?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
  //   emp?.status?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
  //   emp?.candidateEmail?.toLowerCase().includes(this.searchTerm.toLowerCase())  // Adjust keys based on API response
  // );
  // console.log(this.employees);

}

// ============================ Show records ==============================
DislaySelectedRecord(event: any) {
  // this.employees = this.filteredEmployees.slice(0, event.value);
}

// ========================== Download List ==================================

downloadEmployeeList() {
  // if (!this.employees || this.employees.length === 0) {
  //   console.warn('No data available for export');
  //   return;
  // }

  // // Extract only the required fields
  // const filteredData = this.employees.map((employee: any) => ({
  //   Salutation: employee.salutation,
  //   FirstName: employee.firstName,
  //   LastName: employee.lastName,
  //   "Personal Email Id": employee.candidateEmail, // Fixed key with quotes
  //   Status: this.formatedataVariable(employee.status)
  // }));

  // // Convert to Excel format
  // const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
  // const workbook: XLSX.WorkBook = { Sheets: { 'Employees': worksheet }, SheetNames: ['Employees'] };
  // const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  // // Convert to Blob and trigger download
  // const data: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  // FileSaver.saveAs(data, 'Employee_List.xlsx');
}

    
}
